import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MemberSearch } from '../models/member-search';

const getMemberListUrl = '/patients/getMemberListByCharacter.html';
const getRecentlyViewedMembersUrl = '/patients/getRecentlyViewedMembers.html';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private _centerContentText: BehaviorSubject<string> = new BehaviorSubject('');
  centerContentText: Observable<string> = this._centerContentText.asObservable();

  private _pronounText: BehaviorSubject<string> = new BehaviorSubject('');
  pronounText: Observable<string> = this._pronounText.asObservable();

  setPronounText(pronounText: string) {
    this._pronounText.next(pronounText);
  }

  private _refreshCenterContentText: Subject<void> = new Subject();
  refreshCenterContentText: Observable<void> = this._refreshCenterContentText.asObservable();

  constructor(private http: HttpClient) {}

  setCenterContentText(centerContentText: string) {
    this._centerContentText.next(centerContentText);
  }

  emitRefreshCenterContentText() {
    this._refreshCenterContentText.next();
  }

  getMemberList(matchText: string): Observable<MemberSearch[]> {
    return this.http.get<MemberSearch[]>(getMemberListUrl, {
      params: {
        matchText: matchText
      }
    });
  }

  getRecentlyViewedMembers(): Observable<MemberSearch[]> {
    return this.http.get<MemberSearch[]>(getRecentlyViewedMembersUrl);
  }
}
